import { ReactNode } from "react";
import { IButtonItemProps, IconTypesKeys } from "@evergis/ui";
import { Coordinates } from "@evergis/sgis/es/baseTypes";
import { PointLabelSymbolDc } from "@evergis/api";
import { SvgPointSymbol } from "@evergis/react";

export enum SymbolCategoryId {
  Simple = 1,
  Themed = 2,
  Analytic = 3,
  Business = 4,
  Building = 5,
  Food = 6,
  Medicine = 7,
  Transport = 8,
  H3Grid = 9,
  Cluster = 10,
  ClusterDiagram = 11,
  HeatMap = 12,
  Hexagon = 13,
  PolygonVoronoy = 14,
  PolygonS2 = 15,
  ClusterPro = 16,
}

export type SymbolCategory = {
  categoryName: string;
  categoryId: number;
  childs?: SymbolCategory[];
};

export type SymbolItem = {
  symbolId: number;
  categoryId: number;
  name: string;
  type: string;
  form: boolean;
  symbol: {
    type: string;
    data: string;
    size: number;
    offset: Coordinates;
    angle?: number;
    disabled?: boolean;
    background?: {
      id: string;
      type: string;
      fillColor: string;
      strokeColor: string;
      strokeWidth: number;
    };
    figure?: {
      id: string;
      fillColor: string;
    };
  };
};

export type CategoryItem = {
  id: number;
  name: string;
  icon: IconTypesKeys | ReactNode;
  childs: CategoryItem[];
};

export type HeaderProps = {
  categories: CategoryItem[];
  category: CategoryItem;
  selectCategory: (category: CategoryItem) => void;
};

export type NavProps = {
  topCategory: CategoryItem;
  childCategory: CategoryItem;
  categories: CategoryItem[];
  selectCategory: (category: CategoryItem) => void;
  shape: IButtonItemProps;
  selectShape: (shape: IButtonItemProps) => void;
};

export enum SvgSymbolBg {
  Rect = "rect",
  Circle = "circle",
}

export type ListProps = {
  bg: SvgSymbolBg;
  symbols: SymbolItem[];
  selectSymbol: (svg: string, symbol: SvgPointSymbol) => void;
};

export type SvgSymbolProps = {
  svg: string;
  symbol: SvgPointSymbol;
  size?: number;
  title?: string;
  text?: string;
  bg?: SvgSymbolBg;
  skipOffset?: boolean;
  fontSettings?: PointLabelSymbolDc;
  onClick?: (svg: string, symbol: SvgPointSymbol) => void;
};
